import * as Yup from 'yup';

export const projectProposalScheme = Yup.object().shape({
  title: Yup.string().required('Required Field'),
  description: Yup.string().required('Required Field'),
  videoUrl: Yup.string()
  // labels: Yup.array(Yup.string()).required('Required Field')
});
